export default class SLocker {
    constructor(root) {
        this.root = root;

        this.locked = false;
    }

    setState(state) {
        if (typeof scrollLock !== 'object') {
            return;
        }

        switch (state) {
        case 'sheet-show':
            this._setStateSheetShow(); break;
        case 'sheet-hide':
            this._setStateSheetHide(); break;

        case 'time-selector-show':
            this._setStateTimeSelectorShow(); break;
        case 'time-selector-hide':
            this._setStateTimeSelectorHide(); break;

        case 'date-selector-show':
            this._setStateDateSelectorShow(); break;
        case 'date-selector-hide':
            this._setStateDateSelectorHide(); break;

        default:
            console.warn(`Unknow state - ${ state }`); break;
        }
    }

    _setStateSheetShow() {
        if (this.locked) return;

        this.locked = true;

        const scrollable = $('.f-calendar__sheet')[0];

        if (typeof scrollLock === 'object') {
            scrollLock.disablePageScroll(scrollable);
        }
    }

    _setStateSheetHide() {
        this._unlock();
    }

    _setStateTimeSelectorShow() {
        const scrollable = $('.f-calendar__time-selector--list')[0];

        if (typeof scrollLock === 'object') {
            scrollLock.addScrollableTarget(scrollable);
        }
    }

    _setStateTimeSelectorHide() {
        const unscrollable = $('.f-calendar__time-selector--list')[0];

        if (typeof scrollLock === 'object') {
            scrollLock.removeScrollableTarget(unscrollable);
        }
    }

    _setStateDateSelectorShow() {
        const scrollable = $('.f-calendar__date-selector--year-list')[0];
        const unscrollable = $('.f-calendar__sheet')[0];

        if (typeof scrollLock === 'object') {
            scrollLock.addScrollableTarget(scrollable);
            scrollLock.removeScrollableTarget(unscrollable);
        }

        this.root.sheet.$sheet.on('mousewheel.lock touchmove.lock touchstart.lock', (e) => {
            e.preventDefault();
            e.stopPropagation();
            return false;
        });
    }

    _setStateDateSelectorHide() {
        const scrollable = $('.f-calendar__sheet')[0];
        const unscrollable = $('.f-calendar__date-selector--year-list')[0];

        if (typeof scrollLock === 'object') {
            scrollLock.addScrollableTarget(scrollable);
            scrollLock.removeScrollableTarget(unscrollable);
        }

        this.root.sheet.$sheet.off('.lock');
    }

    _unlock() {
        if (!this.locked) return;

        this.locked = false;

        const scrollable = $('.f-calendar__sheet')[0];

        if (typeof scrollLock === 'object') {
            scrollLock.enablePageScroll(scrollable);
        }
    }
}
